"use client"
import Intro from '@/ui/Intro';
import React, { useState } from 'react'
import HosteThumbnail from "@/assets/hostel/hostel-thumbnail.webp";
import Image from 'next/image';

import VideoModal from '@/components/videoModel';

const Ourhostel = () => {
    const [modal, setModal] = useState({ open: false, url: "" });

    return (
        <div className='grid grid-cols-1 md:grid-cols-[2fr_1.6fr] gap-2 items-start my-8 md:my-14 lg:my-16'>
            <div className="w-full bg-white flex justify-baseline items-start">
                <Intro title="More Than a Hostel – It’s a Home"
                    description=" Medhavi Skills University is envisioned as a vibrant educational hub where students 
                and faculty thrive together in a dynamic, collaborative environment focused on excellence in learning, 
                teaching and research. Students can choose from well-furnished single, double, or triple-sharing rooms, 
                with essential amenities for a comfortable stay. Separate hostels for boys and girls are managed 
                by dedicated wardens to ensure safety and smooth operations. All hostels are Wi-Fi enabled, 
                helping students stay connected and focused on their academic goals. We aim to make campus 
                life a true home away from home."
                />
            </div>

            <div className='w-full'>
                <VideoModal
                    open={modal.open}
                    url={modal.url}
                    onClose={() => setModal({ open: false, url: "" })}
                />

                <div className="relative overflow-hidden shadow-md">
                    <Image
                        src={HosteThumbnail}
                        alt="Hoste-Thumbnail"
                        className="w-full h-full object-cover "

                    />
                    <div className="absolute inset-0 bg-black/50 z-10"></div>

                    <div className="absolute inset-0 flex items-center justify-center z-20">
                        <button
                            onClick={() => setModal({
                                open: true,
                                url: "https://www.youtube.com/watch?v=jcWJCUU7BQk"
                            })}
                            className="flex justify-center items-center cursor-pointer w-12 h-12 md:w-14 md:h-14 rounded-full
                            bg-white text-[#081E2D]  p-3 shadow-lg hover:scale-105 transition">
                            <Image
                                src="/play.svg"
                                alt="Play"
                                width={18}
                                height={22}
                                className="ml-1.5 hover:ml-1.5"
                            />
                        </button>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Ourhostel